import * as Types from '../../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import { MemberRowOptionsFragmentDoc } from './row-options';
import { MemberModalFragmentDoc, GroupsFragmentDoc } from './member-modal';
import { InviteLinkModalMemberFragmentDoc } from './invite-link-modal';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkbenchMembersFragment = { __typename?: 'BusinessUser', id: string, accountId: number, status: Types.BusinessUserStatus, firstName?: string | null, lastName?: string | null, email?: string | null, inviteExpired?: boolean | null, organisationId: string, created: string, inviteSecret: string, phone?: string | null, groups: { __typename?: 'BusinessUserGroupsConnection', nodes: Array<{ __typename?: 'BusinessUserGroup', organisationGroup?: { __typename?: 'Group', name: string, id: string } | null }> } };

export type WorkbenchMembersQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.BusinessUsersOrderBy> | Types.BusinessUsersOrderBy;
}>;


export type WorkbenchMembersQuery = { __typename?: 'Query', businessUsers?: { __typename?: 'BusinessUsersConnection', nodes: Array<{ __typename?: 'BusinessUser', accountId: number, id: string, status: Types.BusinessUserStatus, firstName?: string | null, lastName?: string | null, email?: string | null, inviteExpired?: boolean | null, organisationId: string, created: string, inviteSecret: string, phone?: string | null, groups: { __typename?: 'BusinessUserGroupsConnection', nodes: Array<{ __typename?: 'BusinessUserGroup', organisationGroup?: { __typename?: 'Group', name: string, id: string } | null }> } }> } | null, groups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string, description?: string | null }> } | null };

export const WorkbenchMembersFragmentDoc = gql`
    fragment WorkbenchMembers on BusinessUser {
  id
  accountId
  status
  firstName
  lastName
  email
  inviteExpired
  groups: businessUserGroupsByOrganisationIdAndBusinessUserId {
    nodes {
      organisationGroup {
        name
      }
    }
  }
  ...MemberRowOptions
  ...MemberModal
  ...InviteLinkModalMember
}
    ${MemberRowOptionsFragmentDoc}
${MemberModalFragmentDoc}
${InviteLinkModalMemberFragmentDoc}`;
export const WorkbenchMembersDocument = gql`
    query WorkbenchMembers($organisationId: String!, $orderBy: [BusinessUsersOrderBy!]! = [FIRST_NAME_ASC]) {
  businessUsers(condition: {organisationId: $organisationId}, orderBy: $orderBy) {
    nodes {
      accountId
      ...WorkbenchMembers
    }
  }
  groups(condition: {organisationId: $organisationId}) {
    nodes {
      ...Groups
    }
  }
}
    ${WorkbenchMembersFragmentDoc}
${GroupsFragmentDoc}`;

/**
 * __useWorkbenchMembersQuery__
 *
 * To run a query within a React component, call `useWorkbenchMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchMembersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useWorkbenchMembersQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchMembersQuery, WorkbenchMembersQueryVariables> & ({ variables: WorkbenchMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>(WorkbenchMembersDocument, options);
      }
export function useWorkbenchMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>(WorkbenchMembersDocument, options);
        }
export function useWorkbenchMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>(WorkbenchMembersDocument, options);
        }
export type WorkbenchMembersQueryHookResult = ReturnType<typeof useWorkbenchMembersQuery>;
export type WorkbenchMembersLazyQueryHookResult = ReturnType<typeof useWorkbenchMembersLazyQuery>;
export type WorkbenchMembersSuspenseQueryHookResult = ReturnType<typeof useWorkbenchMembersSuspenseQuery>;
export type WorkbenchMembersQueryResult = Apollo.QueryResult<WorkbenchMembersQuery, WorkbenchMembersQueryVariables>;